var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['vuetify-fz', 'fz-32', 'tac', 'suffix', {'required': _vm.isRequired}]},[_c('v-text-field',{attrs:{"value":_vm.data1,"type":"number","min":_vm.float == true ? 0.1 : 0,"suffix":_vm.unit,"step":_vm.float == true ? 0.1 : 1,"placeholder":_vm.label,"hide-details":""},on:{"change":function($event){return _vm.submitData($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }